<template>
    <div id="organ-card" @click.prevent="handleSelectItem">
        <div class="content-info">
            <span style="font-weight: bold;display: block;">{{item.organName||item.siteName}}</span>
            <span style="color: #868686;display: block;">{{item.address||item.siteAddress}}</span>
            <div style="display: inline-flex;align-items: center;width: auto" @click.stop="handleTelEvent(item.phone)">
                <van-icon name="phone" color="#f99231" size="48rpx"></van-icon>
                <span :style="[{color:highlight==item.phone?'red':'#868686'}]">{{item.phoneDesc?item.phoneDesc+'：':''}}{{item.phone}}</span>
            </div>
            <div v-if="item.phoneDesc1" style="display: inline-flex;align-items: center;"
                 @click.stop="handleTelEvent(item.phone1)">
                <van-icon name="phone" color="#f99231" size="48rpx"></van-icon>
                <span :style="[{color:highlight==item.phone1?'red':'#868686'}]">{{item.phoneDesc1?item.phoneDesc1+'：':''}}{{item.phone1}}</span>
            </div>
            <div v-if="item.phoneDesc2" style="display: inline-flex;align-items: center;"
                 @click.stop="handleTelEvent(item.phone2)">
                <van-icon name="phone" color="#f99231" size="48rpx"></van-icon>
                <span :style="[{color:highlight==item.phone2?'red':'#868686'}]">{{item.phoneDesc2?item.phoneDesc2+'：':''}}{{item.phone2}}</span>
            </div>
        </div>
        <div class="location-info" @click.stop="handleLocationEvent(item)">
            <img width="25" height="25" src="../assets/location_icon.png"/>
            <div>{{!item.distance ? '暂无' : (item.distance/1000).toFixed(1) + 'km' }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OrganCard",
        props: {
            highlight: {
                type: String,
                default: ""
            },
            item: {
                type: Object,
                require: true
            },
        },
        components: {
            OrganMap: () => import("../views/organMap/OrganMap.vue")
        },
        methods: {
            handleSelectItem() {
                this.$emit('on-click-item', this.item)
            },
            // 拨打电话
            handleTelEvent(phone) {
                this.$emit("set-highlight", phone)
                window.location.href = "tel://" + phone;
            },
            // 地图
            handleLocationEvent(data) {
                this.$router.push({
                    path: '/organMap',
                    query: data
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    #organ-card {
        border-bottom: 1px solid #ddd;
        background-color: #fff;
        padding: 10px 15px;
        font-size: 14px;
        display: flex;
        align-items: center;

        .content-info {
            flex: 1;
            padding-right: 0.36rem;

            span {
                padding: 0.12rem 0;
            }
        }

        .location-info {
            padding: 0.36rem 0;
            text-align: center;
        }
    }
</style>
